var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.625C11.9467 7.625 11.0565 7.25625 10.4001 6.59987C9.74375 5.9435 9.375 5.05326 9.375 4.125C9.375 3.19674 9.74375 2.3065 10.4001 1.65013C11.0565 0.993749 11.9467 0.625 12.875 0.625C13.8033 0.625 14.6935 0.993749 15.3499 1.65013C16.0063 2.3065 16.375 3.19674 16.375 4.125C16.375 5.05326 16.0063 5.9435 15.3499 6.59987C14.6935 7.25625 13.8033 7.625 12.875 7.625ZM2.375 2.375H7.625V4.125H2.375V14.625H12.875V9.375H14.625V14.625C14.625 15.0891 14.4406 15.5342 14.1124 15.8624C13.7842 16.1906 13.3391 16.375 12.875 16.375H2.375C1.91087 16.375 1.46575 16.1906 1.13756 15.8624C0.809374 15.5342 0.625 15.0891 0.625 14.625V4.125C0.625 3.66087 0.809374 3.21575 1.13756 2.88756C1.46575 2.55937 1.91087 2.375 2.375 2.375Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsPush);
export default __webpack_public_path__ + "static/media/NotificationsPush.3bbc635c1fb6bed5b7fd6b72d26cf7c2.svg";
export { ForwardRef as ReactComponent };